import { IconWithBorder } from "components";
import "./ServiceSliderCardItem.scss";

export interface ServiceSliderCardItemProps {
  icon: string | JSX.Element;
  title: string | JSX.Element;
  text: string | JSX.Element | string[];
  location?: boolean;
}

export function ServiceSliderCardItem({
  icon,
  title,
  text,
  location,
}: ServiceSliderCardItemProps) {
  return (
    <div className="service-slider-card-item">
      <span>
        <IconWithBorder size="large" className="service-slider-card-item__icon">
          {icon}
        </IconWithBorder>
      </span>
      <div className="service-slider-card-item__text">
        <p className="service-slider-card-item__text-title">{title}</p>
        <p
          className="service-slider-card-item__text-info"
          onClick={() =>
            location ? navigator.clipboard.writeText(text as string) : {}
          }
        >
          {text}
        </p>
      </div>
    </div>
  );
}
